import React from 'react';
import Skeleton from 'react-loading-skeleton';

import { Content } from '../../components/shared/Content';

import './FuturePaymentsEfaktura.scss';

const FuturePaymentEfakturaSkeleton: React.FC = () => (
    <Content className="future-payments-efaktura">
        <div className="skeleton-advanced-link-panel">
            <Skeleton style={{ marginBottom: '7px' }} />
            <Skeleton width="40%" />
        </div>
    </Content>
);
export default FuturePaymentEfakturaSkeleton;
